// Shared placeholder detection for site_settings contact fields.
// Public UI (Contact page, footers) uses these to hide seed placeholders until
// real values are set. SEO JSON-LD uses these to avoid emitting fake data to
// search engines. Admin UI is unaffected — admins still see + edit the raw values.

export const isPlaceholderPhone = (v) => {
    if (!v || typeof v !== "string") return true;
    const digits = v.replace(/[^\d]/g, "");
    if (digits.length < 6) return true;
    // Fewer than 3 non-zero digits ⇒ "+44 0000 000000" style placeholder.
    return [...digits].filter((d) => d !== "0").length < 3;
};

export const isPlaceholderEmail = (v) => {
    if (!v || typeof v !== "string") return true;
    const s = v.trim().toLowerCase();
    const placeholders = new Set([
        "hello@omegait.co.uk",
        "test@omegait.co.uk",
        "hello@example.com",
    ]);
    if (placeholders.has(s)) return true;
    return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
};

export const isPlaceholderAddress = (v) => {
    if (!v || typeof v !== "string") return true;
    const s = v.trim().toLowerCase();
    const placeholders = new Set([
        "london, united kingdom",
        "united kingdom",
        "uk",
    ]);
    return placeholders.has(s);
};

const cleanUrl = (v) => {
    if (!v || typeof v !== "string") return null;
    const s = v.trim();
    return s || null;
};

export const cleanContact = (settings = {}) => ({
    email: isPlaceholderEmail(settings.contact_email) ? null : settings.contact_email.trim(),
    phone: isPlaceholderPhone(settings.contact_phone) ? null : settings.contact_phone.trim(),
    address: isPlaceholderAddress(settings.business_address) ? null : settings.business_address.trim(),
    whatsapp: isPlaceholderPhone(settings.whatsapp_number) ? null : settings.whatsapp_number.trim(),
    instagram: cleanUrl(settings.instagram_url),
    facebook: cleanUrl(settings.facebook_url),
    linkedin: cleanUrl(settings.linkedin_url),
});

export const hasAnyContact = (c) => Boolean(c.email || c.phone || c.address || c.whatsapp);
export const hasAnySocial = (c) => Boolean(c.instagram || c.facebook || c.linkedin);
